var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 133 134",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65,
    r: 47.5,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m90.482 49.505 6.3429-1.529-6.4262-1.548-1.544-6.0444-1.5441 6.0444-6.4261 1.548 6.3428 1.529 1.6274 6.373 1.6273-6.373z",
    fill: "#FD9558"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m40.219 59.439 3.8029-0.9167-3.8528-0.9281-0.9258-3.6239-0.9257 3.6239-3.8529 0.9281 3.8029 0.9167 0.9757 3.821 0.9757-3.821z",
    fill: "#FFB762"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m69.816 71.038c2.5982-16.659 10.604-21.228 10.604-21.228-3.7307 6.6967-6.561 13.831-8.4214 21.228h-2.1822z",
    fill: "#1E7836"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m72.912 71.038c1.6759-11.188 9.2473-9.7882 9.2473-9.7882s-3.4421-0.9665-7.0651 9.7882h-2.1822z",
    fill: "#1E7836"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m72.912 71.038c1.6759-11.188 9.2473-9.7882 9.2473-9.7882s-5.2144-0.9665-8.8313 9.7882h-0.416z",
    fill: "#1E7836"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m56.288 71.184c-1.3442-11.235-8.9519-10.04-8.9519-10.04s3.4663-0.8904 6.7637 9.9581l2.1882 0.082z",
    fill: "#1E7836"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m56.408 71.078c-1.6156-11.171-9.1931-9.8352-9.1931-9.8352s5.2084-0.9548 8.7711 9.8352h0.422z",
    fill: "#1E7836"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m58.892 71.096c-2.4534-16.677-10.423-21.31-10.423-21.31 3.673 6.7258 6.4425 13.882 8.2405 21.293l2.1822 0.0176z",
    fill: "#1E7836"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m58.892 71.097c-2.4535-16.677-9.5186-20.648-9.5186-20.648s6.1428 4.8912 8.4396 20.631l1.079 0.0176z",
    fill: "#1E7836"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m62.217 71.038c0.6028-16.923-5.9378-35.808-5.9378-35.808s0.3496 23.847 3.7676 35.808h2.1702z",
    fill: "#1E7836"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m60.714 71.038c-1.4287-15.523-4.4187-35.808-4.4187-35.808s0.3376 23.847 3.7556 35.808h0.6631z",
    fill: "#1E7836"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m66.835 71.038c-0.3978-16.952 6.4141-35.732 6.4141-35.732s-0.6511 23.823-4.2198 35.732h-2.1943z",
    fill: "#1E7836"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m67.715 71.038c0.7475-17.573 5.5339-34.777 5.5339-34.777s-0.651 22.845-4.2197 34.783l-1.3142-0.0058z",
    fill: "#1E7836"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m63.329 71.038c-0.4039-16.935 0.4521-39.616 0.4521-39.616s5.3109 27.689 1.7361 39.616h-2.1882z",
    fill: "#1E7836"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m73.076 91.71h-19.941l-3.0623-22.06h25.68l-2.6766 22.06z",
    fill: "#FD9558"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m78.162 74.191-2.3791 20.41h-17.702l-2.7239-20.41h22.805z",
    fill: "#fff",
    stroke: "#FD9558"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m88.218 99.466h-49.22l-3.195-13.836h55.478l-3.0623 13.836z",
    fill: "#00C65E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m88.46 99.741h-49.709l-3.3276-14.41h56.231l-3.1949 14.41zm-49.226-0.5858h48.738l2.9357-13.256h-54.73l3.0563 13.256z",
    fill: "#00C65E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m84.265 87.076-2.351-0.5272c1.4588-6.1389 3.2431-10.456 5.2927-12.828 1.7301-2.0092 3.1468-2.0209 3.5386-1.9741 0.3702 0.026 0.7293 0.1346 1.0493 0.3175 0.3199 0.1829 0.5921 0.4351 0.7953 0.7369 1.3202 1.8394 0.8922 6.4435-1.2659 13.637l-2.3148-0.6561c2.6765-8.9271 1.9049-11.499 1.5492-11.715-0.3436 0.0937-3.4662 1.1071-6.2934 13.01z",
    fill: "#00C65E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m35.896 86.79c-2.6585-6.9121-3.4241-11.423-2.2727-13.402 0.1843-0.3288 0.4427-0.6128 0.7558-0.8309 0.3132-0.2181 0.6731-0.3646 1.0527-0.4285 0.8018-0.1874 5.3169-0.4335 9.8561 13.83l-2.3027 0.6912c-2.0255-6.3615-3.9124-9.3724-5.1421-10.761-1.1213-1.2829-1.8567-1.4293-2.0074-1.4469-0.0422 0-0.0663 0.041-0.1025 0.0996-0.5425 0.9372-0.2351 4.4929 2.4113 11.422l-2.2485 0.826zm0-12.372h-0.0483 0.0483z",
    fill: "#00C65E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m44.222 99.758h0.7174l-2.339-14.439h-0.7113l2.3329 14.439z",
    fill: "#FFB762"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m40.724 99.776 1.3142 0.0058-2.333-14.439-1.3201-0.0058 2.3389 14.439z",
    fill: "#FFB762"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m48.569 99.776 0.4461 0.0058-2.3389-14.439-0.4401-0.0058 2.3329 14.439z",
    fill: "#FFB762"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m78.4 99.764h-1.3142l2.4113-14.428h1.3142l-2.4113 14.428z",
    fill: "#FFB762"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m85.205 99.764h-2.5198l2.4113-14.428h2.5198l-2.4113 14.428z",
    fill: "#FFB762"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0.5,
    width: 133,
    height: 133,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 3,
    result: "effect1_dropShadow_5137_20202"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.211765 0 0 0 0 0.227451 0 0 0 0 0.270588 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5137_20202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5137_20202",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.cdb3056135febee32180dc83b0dd3779.svg";
export { ForwardRef as ReactComponent };